module.exports = __webpack_public_path__ + "static/profile-865866b5be803eaa5d95d3403aeeba2e.jpg";